var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-md-4 grid-card cols" }, [
    _c("div", { staticClass: "inner-wrapper" }, [
      _c("a", { staticClass: "image-link", attrs: { href: _vm.item.link } }),
      _vm._v(" "),
      _c("div", { staticClass: "image" }, [
        _c("div", { staticClass: "image-wrapper", style: _vm.backgroundImage }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("a", { staticClass: "cta" }, [
          _c("span", [_vm._v(_vm._s(_vm.item.title.rendered))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "department-name" }, [
          _vm._v(_vm._s(_vm.item.acf.title)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/FacultyCard.vue